export const separateOnCapitalLetters = (str) => {
    return str.replace(/([A-Z])/g, ' $1').trim();
};